<template>
  <transition name="fade">
    <Modal v-cloak v-if="showModal" @close="closeModal">
      <slot></slot>
    </Modal>
  </transition>
</template>

<script>
import Cookies from "js-cookie";
import Modal from "./Modal.vue";

export default {
  name: "ModalPopup",
  components: { Modal },
  props: {
    blockId: {
      type: String,
      default: null,
    },
    durationDays: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showModal: true,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
      Cookies.set(`popup-${this.blockId}`, "closed", {
        expires: this.durationDays,
      });
    },
  },
};
</script>
